module.exports = __webpack_public_path__ + "img/server.b14319d4.png";